<template>
  <div class="invoices root">
    <div v-if="disablePage" class="text-center pt-4">Coming soon...</div>
    <div v-if="!disablePage" class="listData px-3">
      <div
        v-if="saleType === 'wholesale' || saleType === 'exclusivity'"
        class="wholesale-calendar-wrapper pt-4"
      >

        <WholesaleCalendar
          :dataList="targetList"
          v-if="targetList.length > 0"
        />
        <b>ประวัติคะแนน</b>
      </div>
      <!-- Filter ประเภทออเดอร์ -->
      <div class="order-type-filter">
        <button
          type="button"
          class="filter-btn"
          :class="{ active: orderTypeFilter === 'all' }"
          @click="orderTypeFilter = 'all'"
        >ทั้งหมด</button>
        <button
          type="button"
          class="filter-btn"
          :class="{ active: orderTypeFilter === 'online' }"
          @click="orderTypeFilter = 'online'"
        >ออนไลน์</button>
        <button
          type="button"
          class="filter-btn"
          :class="{ active: orderTypeFilter === 'offline' }"
          @click="orderTypeFilter = 'offline'"
        >ออฟไลน์</button>
        <button
          type="button"
          class="filter-btn"
          :class="{ active: orderTypeFilter === 'extra' }"
          @click="orderTypeFilter = 'extra'"
        >คะแนนพิเศษ</button>
      </div>
      <div>
        <!-- Table Header -->
        <div class="invoice-table-header">
          <div class="col-date">วันที่</div>
          <div class="col-order">เลขที่ใบเสร็จ</div>
          <div class="col-point">คะแนน</div>
          <div class="col-action"></div>
        </div>
        <!-- Table Rows -->
        <div v-for="(it, index) in filteredAndSortedInvoices" :key="index" class="invoice-table-row">
          <div class="col-date">{{ dateTolocal(it.transactionDate) }}</div>
          <div class="col-order">
            <span v-if="isOnlineByReceipt(it)">ID. {{ it.refOrderInfo || $invoToString(it.receiptNo) }}</span>
            <span v-else>{{ $invoToString(it.receiptNo) || it.refOrderInfo }}</span>
            <div class="order-type-label">
              <span v-if="it.isExtra == 1">คะแนนพิเศษ</span>
              <span v-else-if="isOnlineByReceipt(it)">ออเดอร์ ออนไลน์</span>
              <span v-else>ออเดอร์ ออฟไลน์</span>
            </div>
            <div v-if="it.isExtra == 1 && it.campainName" class="campain-label">{{ it.campainName }}</div>
          </div>
          <div class="col-point">
            <span v-if="it.point" class="point-value">+{{ it.point }}</span>
            <span v-else class="point-dash">-</span>
          </div>
          <div class="col-action">
            <button
              v-if="it.status === 'uncollect' && buttonVisible && it.isExtra != 1"
              class="btn-confirm"
              @click="confirmClick(dateTolocal(it.transactionDate), it.id, it.receiptNo)"
            >กดยืนยัน<br/>รับคะแนน</button>
            <span v-else-if="it.status === 'pending'" class="badge-pending">รอตรวจสอบ</span>
            <span v-else-if="it.status === 'incomplete'" class="badge-incomplete" @click="incompleteAlert()">ไม่สมบูรณ์</span>
          </div>
        </div>
        <infinite-loading
          v-if="infinShow"
          @infinite="getInvoice"
          ref="infiniteLoading"
          spinner="waveDots"
          force-use-infinite-wrapper="#main_content"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div
          v-if="dataStage === 'already' && !infinShow && filteredAndSortedInvoices.length > 0"
          class="invoice-list-end text-center text-muted py-3"
          role="status"
        >
          สิ้นสุดรายการแล้ว
        </div>
      </div>
      <div v-if="dataStage == 'loading'">
        <vue-content-loading
          v-for="i in 6"
          :key="i + '_'"
          :weight="100"
          :height="130"
        >
          <rect :y="45" rx="4" ry="4" width="40%" height="15" />
          <rect y="85" rx="4" ry="4" width="60%" height="15" />
          <rect y="25" x="77%" rx="15" ry="15" width="23%" height="69%" />
        </vue-content-loading>
      </div>
      <div v-if="dataStage == 'error'" class="text-center pt-4">
        Coming soon!
        <!-- มีข้อผิดพลาด กรุณาลองอีกครั้ง หรือติดต่อเจ้าหน้าที่ -->
      </div>
      <div v-if="dataStage == 'nodata'" class="text-center pt-4">
        Coming soon
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { forEach, size } from "lodash";
import VueContentLoading from "vue-content-loading";
import InfiniteLoading from "vue-infinite-loading";
import WholesaleCalendar from "@/components/wholesaleCalendar";

export default {
  name: "invoices",
  components: {
    VueContentLoading,
    InfiniteLoading,
    WholesaleCalendar,
  },
  computed: {
    filteredAndSortedInvoices() {
      const list = this.data_invoices || [];
      let filtered = list;
      if (this.orderTypeFilter === "online") {
        filtered = list.filter(
          (it) => this.isOnlineByReceipt(it) && it.isExtra != 1
        );
      } else if (this.orderTypeFilter === "offline") {
        filtered = list.filter((it) => !this.isOnlineByReceipt(it));
      } else if (this.orderTypeFilter === "extra") {
        filtered = list.filter((it) => it.isExtra == 1);
      }
      return [...filtered].sort(
        (a, b) => new Date(b.transactionDate) - new Date(a.transactionDate)
      );
    },
    saleType() {
      const { user_data } = this.$store.state;
      const customerSaleType = user_data?.customerSaleType;
      const shopCode = user_data?.shopCode;
      if (customerSaleType?.toLowerCase() === "wholesale") {
        this.getPoint(shopCode);
      }
      return customerSaleType ? customerSaleType.toLowerCase() : "";
    },
    buttonVisible() {
      // const { user_data } = this.$store.state;
      return new Date() > new Date(2023, 10, 21);
    },
    targetList() {
      const { dataList } = this;
      const { wholesaleTarget } = this.$store.state;
      let newArray = [];
      if (size(dataList) > 0 && size(wholesaleTarget) > 0) {
        if (size(dataList) > size(wholesaleTarget)) {
          forEach(dataList, (i, index) => {
            newArray.push({
              ...dataList[index],
              ...wholesaleTarget.find(
                (j) =>
                  j.month === dataList[index].month &&
                  j.year === dataList[index].year
              ),
            });
          });
        } else {
          forEach(wholesaleTarget, (i, index) => {
            newArray.push({
              ...wholesaleTarget[index],
              ...dataList.find(
                (j) =>
                  j.month === wholesaleTarget[index].month &&
                  j.year === wholesaleTarget[index].year
              ),
            });
          });
        }
      }
      const result = this.generateList(newArray) || [];
      return result;
    },
  },
  watch: {
    orderTypeFilter() {
      // a shorter filtered list may expose the loader without any scroll event
      this.$nextTick(() => {
        const wrapper = document.getElementById("main_content");
        if (wrapper) wrapper.dispatchEvent(new Event("scroll"));
      });
    },
  },
  data() {
    return {
      orderTypeFilter: "all", // 'all' | 'online' | 'offline'
      dataStage: "loading",
      next_page_url: `${process.env.VUE_APP_API_URL}/invoices?page=1`,
      data_invoices: [],
      infinShow: false,
      total: 0,
      used: 0,
      remain: 0,
      pending: 0,
      dataList: [],
      disablePage: false,
    };
  },
  methods: {
    isOnlineByReceipt(it) {
      const str = [it.receiptNo, it.refOrderInfo].filter(Boolean).join(" ");
      const lower = String(str).toLowerCase();
      return lower.includes("bfm") || lower.includes("fsrm");
    },
    async fetchInvoices() {
      // get shop info
      return await fetch(this.next_page_url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.$JWT}`,
        },
      });
    },
    async getInvoice($state) {
      try {
        const res = await this.fetchInvoices();
        console.log("fetchInvoices status:", res.status);
        let body = [];
        switch (res.status) {
          case 200: {
            this.dataStage = "already";
            body = await res.json();
            this.next_page_url = body.nextPageUrl;
            this.data_invoices = this.data_invoices.concat((body.data || []));
            const hasMore =
              this.data_invoices.length > 0 &&
              !!body.nextPageUrl &&
              body.currentPage < body.lastPage;
            if (this.data_invoices.length == 0) {
              this.dataStage = "nodata";
            }
            this.infinShow = hasMore;
            if ($state) {
              // vue-infinite-loading stays in "loading" until told otherwise
              this.$nextTick(() => (hasMore ? $state.loaded() : $state.complete()));
            }
            break;
          }
          case 401: {
            this.$Error401();
            throw "401";
          }
          default: {
            throw "no case";
          }
        }
      } catch (error) {
        console.log(error);
        if ($state) $state.complete();
        this.loadingData = false;
        this.infinShow = false;
        this.dataStage = "error";
      }
    },
    generateList(list) {
      const newArray = [];
      if (size(list) > 0) {
        list.forEach((e) => {
          if (e.isMock) {
            newArray.push({
              month: e.month,
              year: e.year,
              data: [],
            });
          } else {
            newArray.push({
              month: e.month,
              year: e.year,
              data: [
                {
                  title: "เป้าการสั่งซื้อต่อเดือนที่รับคะแนนพิเศษ",
                  amount: e.targetReach,
                  unit: "บาท",
                },
                {
                  title: "ยอดการสั่งซื้อ",
                  amount: e.currentTarget,
                  unit: "บาท",
                },
                {
                  title: "% เทียบเป้า",
                  amount: e.percentage,
                  unit: "%",
                },
                {
                  title: "คะแนนที่ได้รับในการสั่งซื้อ",
                  amount: e.receive,
                  unit: "คะแนน",
                },
                {
                  title: "คะแนนพิเศษที่ได้รับเมื่อผ่านเป้า",
                  amount: e.special,
                  unit: "คะแนน",
                },
                {
                  title: "คะแนนรวม",
                  amount: e.accumulateReceive,
                  unit: "คะแนน",
                },
              ],
            });
          }
        });
        newArray.sort((a, b) => {
          if (a.year === b.year) {
            return a.month - b.month;
          } else {
            return a.year - b.year;
          }
        });
      }
      return newArray;
    },
    async getPoint(shopCode) {
      try {
        const res = await fetch(
          `${process.env.VUE_APP_API_URL}/shop/${shopCode}/wholesalePoint`,
          {
            headers: {
              Authorization: `Bearer ${this.$JWT}`,
            },
          }
        );
        const { status } = res;
        switch (status) {
          case 200: {
            const body = await res.json();
            const { months, receive, used, remain, pending } = body;
            this.total = receive;
            this.used = used;
            this.remain = remain;
            this.pending = pending;
            this.dataList = months;
            break;
          }
          default:
            throw "Something when wrong!";
        }
      } catch (e) {
        console.log(e);
      }
    },
    dateTolocal(val) {
      return new Date(val)
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .split(",")[0];
    },
    confirmClick(date, id, ref) {
      if (!this.$readOnly) {
        this.$router.push({
          name: "confirmPoint",
          params: { transDate: date, invoiceID: id, refOrder: ref },
        });
      }
    },
    incompleteAlert() {
      if (!this.$readOnly) {
        this.Swal.fire(
          "รายการไม่สมบูรณ์",
          "ยังไม่สามารถคำนวณคะแนนได้ โปรดติดต่อเจ้าหน้าที่",
          "warning"
        );
      }
    },
  },
  async mounted() {
    window.loading(false);
    if (!this.disablePage) {
      this.getInvoice();
    }
  },
};
</script>

<style lang="scss" scoped>
$blue: #00B14D;
$gray: #ced3da;
$green: #00B14D;
$green-light: #e8f8ef;

.root {
  font-size: 14px;
  background: #f8f9fa;
}

.listData {
  padding: 0 !important;
}

.order-type-filter {
  display: flex;
  gap: 8px;
  padding: 12px 0 8px;
  flex-wrap: wrap;
  margin-left: 10px;
}

.filter-btn {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid $gray;
  background: #fff;
  color: #666;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;

  &.active {
    background: $green;
    border-color: $green;
    color: #fff;
  }

  &:active {
    opacity: 0.9;
  }
}

.invoice-table-header,
.invoice-table-row {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  gap: 6px;
}

.invoice-table-header {
  font-weight: 700;
  font-size: 13px;
  background: $green-light;
  color: #444;
  border-bottom: 2px solid darken($green-light, 5%);
  position: sticky;
  top: 0;
  z-index: 1;
}

.invoice-table-row {
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  color: #333;
  background: #fff;
  transition: background 0.15s;

  &:hover {
    background: #fafafa;
  }
}

.col-date {
  flex: 0 0 76px;
  min-width: 76px;
  font-size: 12px;
  color: #666;
}

.col-order {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  font-size: 12px;
  color: #333;

  .order-type-label {
    font-size: 11px;
    color: #888;
    margin-top: 2px;
  }
}

.col-point {
  flex: 0 0 52px;
  min-width: 52px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.col-action {
  flex: 0 0 84px;
  min-width: 84px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.point-value {
  font-weight: 700;
  font-size: 14px;
  color: $green;
}

.point-dash {
  color: #ccc;
}

.badge-pending {
  display: inline-block;
  background: #f5f5f5;
  color: #999;
  font-size: 11px;
  border-radius: 12px;
  padding: 3px 8px;
  white-space: nowrap;
  text-align: center;
}

.badge-incomplete {
  display: inline-block;
  background: #fff0f0;
  color: #d9534f;
  font-size: 11px;
  border-radius: 12px;
  padding: 3px 8px;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
}

.campain-label {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}

.btn-confirm {
  background: $green;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 177, 77, 0.25);

  &:active {
    opacity: 0.85;
    transform: scale(0.97);
  }
}

.wholesale-calendar-wrapper {
  font-size: 16px;
  hr {
    border-color: $gray;
    border-width: 5px;
  }
  .score-container {
    background: $blue;
    color: #fff;
  }
  .remark-container {
    font-size: 11px;
  }
}

.hilight {
  color: #fbc02d;
}

@media screen and (max-width: 400px) {
  .root {
    font-size: 12px;
  }
}
</style>
